import { createContext, useState } from "react";

const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState({});
  const [persist, setPersist] = useState(JSON.parse(localStorage.getItem("persist")) || false)
  const baseUrl = 'http://localhost:8000'
  // const baseUrl = 'https://api.jjmdev.xyz'

  return (
    <AuthContext.Provider value={{ auth, setAuth, persist, setPersist, baseUrl }}>
      {children}
    </AuthContext.Provider>
  )
}

export default AuthContext;